<template>
  <div class="mx-auto max-w-7xl sm:px-6 sm:py-6 lg:px-8 lg:py-8">
    <slot />
  </div>
</template>
